<template>
  <div class="container">
    <PullRefresh
      v-model="isLoading"
      success-text="刷新成功"
      @refresh="onRefresh"
    >
      <div class="pageNative" style="padding: 10px">
        <div class="activity_places relative mt_6 pb_8 round_5">
          <div v-if="games.length > 0">
            <div
              v-for="item in theTop5Games"
              :key="item.gameId"
              :style="{ display: 'inline-block', position: 'relative' }"
            >
              <img
                :src="item.gameIcon"
                class="place_icon ml_8"
                :class="{ active_place: item.activityGameId == selectPlaceId }"
                @click="onChangeGame(item)"
              />
            </div>
          </div>
          <div
            v-if="games.length > 4"
            class="morePlace"
            @click="handleShowMoreGameModal"
          >
            <img :src="`${CDN_URL_1}/box_payAmount/more.png`" />
            <p class="moreText">更多游戏</p>
          </div>
        </div>
        <div class="title">
          <img style="width: 99px" :src="`${CDN_URL}/wel.png`" />
        </div>
        <div class="header">
          <div
            class="rec_item bg_contain"
            :style="{
              backgroundImage: `url(${CDN_URL}/game_wrap.png)`,
              backgroundSize: '100% 100%'
            }"
          >
            <div
              class="rec_img bg_contain"
              :style="{
                backgroundImage: `url(${gameInfo.gameIcon})`
              }"
            >
            </div>
            <div class="rec_info">
              <div class="rec_title" style="display: flex; align-items: center;">
                <div>{{ gameInfo.gameName }}</div>
                <div class="isplay scale09">在玩</div>
              </div>
              <div class="rec_desc van-ellipsis scale09">共{{ gameInfo.giftNum }}个游戏礼包</div>
            </div>
          </div>
        </div>
        <div class="gift_list">
          <div class="gift_list_wrap">
            <div
              v-for="gift in giftList"
              :key="gift.activityGiftId"
              class="rec_item gift_item"
            >
              <div
                class="rec_img bg_contain"
                :style="{
                  backgroundImage: `url(${gift.giftIcon})`
                }"
              >
              </div>
              <div class="rec_info">
                <div class="rec_title" style="margin-bottom: 6px;">{{ gift.giftName || `${gift.credit} 积分` }}</div>
                <div class="rec_content van-ellipsis scale09 mb_4">{{ gift.desc }}</div>
                <div class="rec_desc van-ellipsis scale09">
                  {{ getConditionStr(gift) }}
                </div>
              </div>
              <div
                class="rec_btn bg_contain flex_center gift_btn"
                :class="{ filter_grayscale: gift.drawStatus === 1 }"
                :style="{
                  backgroundImage: `url(${CDN_URL}/btn2.png)`,
                }"
                @click="onReceiveGift(gift)"
              >{{ gift.drawStatus === 1 ? '已领取' : '领取' }}</div>
            </div>
          </div>
        </div>
      </div>
    </PullRefresh>
    <ActivityPopup
      :visible.sync="visible"
      v-bind="feedback"
      :showProgress="[3, 4].includes(feedbackType)"
      :progressAttrs="progressAttrs"
      :headerStyle="{
        background: '#6600FF'
      }"
      :innerTitleStyle="{
        color: '#333',
      }"
      confirmButtonColor="#6600FF"
      cancelButtonColor="#828282"
      @confirm="feedback.onSure"
      @cancel="feedback.onCancel"
    >
      <template v-if="feedbackType === 5">
        <div class="more_games">
          <div 
            v-for="item in games"
            :key="item.gameId"
            class="more_game text_center relative"
            @click="onHandlePlace(item)"
          >
            <div
              class="more_game_icon bg_contain"
              :style="{
                backgroundImage: `url(${item.gameIcon})`
              }"
            ></div>
            <div class="more_game_name scale09_center fs_12">{{ item.gameName }}</div>
          </div>
        </div>
      </template>
    </ActivityPopup>
  </div>
</template>

<script>
import { jumpToNative, setRightTxt, toLogin } from "@/bridge/AppJsBridge"
import {
  receiveGameTransferGiftApi, getGameTransferGiftListApi,
  getGameTransferGameListApi,
} from '@/apis/btBoxActivity'
import EventTrack from '@/mixins/eventTrack'
import AvoidFirstActivate from '@/mixins/avoidFirstActivate'
import { PullRefresh } from "vant";
import ActivityPopup from '@/components/btBox/ActivityPopup.vue';
import { CDN_URL_1 } from "@/config";

const codeMapType = {
  94007: 1,
  94008: 2,
  94010: 3,
}

export default {
  components: {
    PullRefresh,
    ActivityPopup,
  },
  beforeCreate () {
    // 
  },
  mixins: [EventTrack, AvoidFirstActivate],
  data () {
    return {
      CDN_URL_1,
      CDN_URL: CDN_URL_1 + '/box_game_transfer',
      skipInit: true, // 避免重复 init webview 对象
      visible: false,
      feedbackType: 0,
      progressAttrs: {
        currentVal: 0,
        targetVal: 100,
        skins: {
          color: '#333',
          background: '#6600FF',
          borderColor: '#333',
        },
      },
      giftList: [],
      curGift: {},
      gameInfo: {},
      isLoading: false,
      receiveLoading: false,
      levelInfo: {},
      selectPlaceId: '', // 多个游戏时，当前选中的游戏会场 id
      games: [],
    }
  },
  activated () {
    setRightTxt('');
  },
  computed: {
    isWx () {
      return this.$route.query.app * 1 !== 1
    },
    actParams () {
      const { id, level } = this.$route.query
      return {
        activityId: id,
        levelId: level,
      }
    },
    // 排序前 5 的游戏  并且将选中的游戏放到第一位
    theTop5Games () {
      const gList = this.games
      if (!Array.isArray(gList) || !gList.length) return []
      const maxCount = 5
      const currentIdx = gList.findIndex(it => it.activityGameId === this.selectPlaceId)
      const res = [gList[currentIdx]]
      gList.forEach(it => {
        if (res.length === maxCount) return
        if (it.activityGameId === this.selectPlaceId) return
        res.push(it)
      })
      return res
    },
    trackGameParams () {
      const { gameId, gameName } = this.gameInfo
      return {
        appkey: gameId,
        appName: gameName,
      }
    },
    feedback () {
      return this.feedbackMap[this.feedbackType]
    },
    feedbackMap () {
      return [
        {
          title: '领取成功',
          message: [
            '礼包码已存放在',
            '【我的】-【我的礼包】-【活动礼包】'
          ],
          confirmButtonText: '查看礼包码',
          onSure: () => {
            const { giftId, giftName, drawCondite, level } = this.curGift
            const { giftValue } = this.levelInfo
            this.eventTrack({
              event: "game_transfer_draw_success_button",
              event_field: this.getTrackInfo({
                level,
                gift_id: giftId,
                gift_name: giftName,
                gift_value: giftValue,
                draw_condite: drawCondite,
                type: 1,
              }),
              ...this.trackGameParams,
            })
            this.handleGoGift()
            this.triggerVisible(false)
          },
          onCancel: () => {
            this.triggerVisible(false)
          }
        },
        {
          title: '提示',
          message: [
            '兑换码生成错误',
            '请联系客服领取备用码'
          ],
          confirmButtonText: '联系客服',
          onSure: () => {
            const { giftId, giftName, drawCondite, level } = this.curGift
            const { giftValue } = this.levelInfo
            this.eventTrack({
              event: "game_transfer_draw_success_button",
              event_field: this.getTrackInfo({
                level,
                gift_id: giftId,
                gift_name: giftName,
                gift_value: giftValue,
                draw_condite: drawCondite,
                type: 2,
              }),
              ...this.trackGameParams,
            })
            this.triggerVisible(false)
            this.onRelationServer()
          },
          onCancel: () => {
            this.triggerVisible(false)
          }
        },
        {
          title: '不满足领取条件',
          message: [
            '未查询到游戏记录',
            '在活动时间内下载游戏并用此账号创角',
            '即可领取该礼包'
          ],
          confirmButtonText: '去完成',
          onSure: () => {
            const { giftId, giftName, drawCondite, level } = this.curGift
            const { giftValue } = this.levelInfo
            this.eventTrack({
              event: "game_transfer_to_complete_button",
              event_field: this.getTrackInfo({
                level,
                gift_id: giftId,
                gift_name: giftName,
                gift_value: giftValue,
                draw_condite: drawCondite,
                type: 1,
              }),
              ...this.trackGameParams,
            })
            this.triggerVisible(false)
            this.handleGoGameDetail()
          },
          onCancel: () => {
            this.triggerVisible(false)
          }
        },
        {
          title: '不满足领取条件',
          message: [
            `角色达${this.curGift.condite}级即可领取礼包`
          ],
          confirmButtonText: '去完成',
          onSure: () => {
            const { giftId, giftName, drawCondite, level } = this.curGift
            const { giftValue } = this.levelInfo
            this.eventTrack({
              event: "game_transfer_to_complete_button",
              event_field: this.getTrackInfo({
                level,
                gift_id: giftId,
                gift_name: giftName,
                gift_value: giftValue,
                draw_condite: drawCondite,
                type: 2,
                cur_value: this.progressAttrs.currentVal,
                tar_value: this.progressAttrs.targetVal,
              }),
              ...this.trackGameParams,
            })
            this.triggerVisible(false)
            this.handleGoGameDetail()
          },
          onCancel: () => {
            this.triggerVisible(false)
          }
        },
        {
          title: '不满足领取条件',
          message: [
            `活动期间充值金额`,
            `达到${this.curGift.condite}元即可领取礼包`
          ],
          confirmButtonText: '去完成',
          onSure: () => {
            const { giftId, giftName, drawCondite, level } = this.curGift
            const { giftValue } = this.levelInfo
            this.eventTrack({
              event: "game_transfer_to_complete_button",
              event_field: this.getTrackInfo({
                level,
                gift_id: giftId,
                gift_name: giftName,
                gift_value: giftValue,
                draw_condite: drawCondite,
                type: 3,
                cur_value: this.progressAttrs.currentVal,
                tar_value: this.progressAttrs.targetVal,
              }),
              ...this.trackGameParams,
            })
            this.triggerVisible(false)
            this.handleGoGameDetail()
          },
          onCancel: () => {
            this.triggerVisible(false)
          }
        },
        {
          title: '更多游戏',
          innerTitle: '请选择',
          message: [],
          showConfirmButton: false,
          onSure: () => {
            this.triggerVisible(false)
          },
          onCancel: () => {
            this.triggerVisible(false)
          }
        },
        {
          title: '领取成功',
          message: [
            '积分可用于在【积分商城】兑换游戏道具',
          ],
          confirmButtonText: '去使用积分',
          onSure: () => {
            const { giftId, giftName, drawCondite, level } = this.curGift
            const { giftValue } = this.levelInfo
            this.eventTrack({
              event: "game_transfer_draw_success_button",
              event_field: this.getTrackInfo({
                level,
                gift_id: giftId,
                gift_name: giftName,
                gift_value: giftValue,
                draw_condite: drawCondite,
                type: 3,
              }),
              ...this.trackGameParams,
            })
            this.handleGoScore()
            this.triggerVisible(false)
          },
          onCancel: () => {
            this.triggerVisible(false)
          }
        },
      ]
    },
  },

  methods: {
    init () {
      return this.getGamesInLevel().then(() => {
        this.getGiftList()
      })
    },
    onRefresh () {
      this.init().finally(res => {
        this.isLoading = false
      })
    },
    getActivityInfo () {
      this.init()
    },
    getGiftList () {
      return getGameTransferGiftListApi({
        ...this.actParams,
        activityGameId: this.selectPlaceId,
      }, !this.isWx).then(res => {
        // rest -> gameIcon/gameId/gameName
        const { gameGiftVoList, level, giftValue, ...rest } = res.data
        this.gameInfo = rest
        this.levelInfo = {
          level,
          giftValue,
        }
        this.giftList = gameGiftVoList || []
      })
    },
    // 获取已解锁的游戏
    getGamesInLevel () {
      return getGameTransferGameListApi({
        ...this.actParams,
      }, !this.isWx).then(res => {
        this.games = res.data
        this.selectPlaceId = this.games[0].activityGameId
      }).catch(error => {
        let errorInfo = error.response;
        const { data } = errorInfo;
        if (data && data.code === 401) {
          toLogin("/loginKey/LoginByKeyPhoneActivity");
        }
      })
    },
    onChangeGame (game) {
      const { activityGameId, gameId, gameName } = game
      if (activityGameId === this.selectPlaceId && !this.visible) return
      this.selectPlaceId = activityGameId
      this.getGiftList().then(res => {
        this.eventTrack({
          event: "game_transfer_game_icon",
          event_field: this.getTrackInfo({
            level: this.levelInfo.level,
            gift_value: this.levelInfo.giftValue,
          }),
          appkey: gameId,
          appName: gameName,
        })
      })
    },
    onHandlePlace (game) {
      this.onChangeGame(game)
      this.triggerVisible(false)
    },
    handleShowMoreGameModal () {
      this.triggerVisible(true, 5)
    },
    // 领取礼包
    onReceiveGift (gift) {
      this.curGift = gift
  
      // 已领取
      if (gift.drawStatus === 1) {
        // this.triggerVisible(true, 0)
        return
      }

      if (this.receiveLoading) return
      this.receiveLoading = true

      const { giftId, giftName, drawCondite, level, rewardType } = this.curGift
      // rewardType 1 礼包 2 积分
      const { giftValue } = this.levelInfo

      this.eventTrack({
        event: "game_transfer_draw_button",
        event_field: this.getTrackInfo({
          level,
          gift_id: giftId,
          gift_name: giftName,
          gift_value: giftValue,
          draw_condite: drawCondite,
        }),
        ...this.trackGameParams,
      })

      receiveGameTransferGiftApi({
        activityGiftId: gift.activityGiftId,
      }, !this.isWx).then(res => {
        const { code, data } = res
        this.eventTrack({
          event: "game_transfer_draw_success_pop",
          event_field: this.getTrackInfo({
            level,
            gift_id: giftId,
            gift_name: giftName,
            gift_value: giftValue,
            draw_condite: drawCondite,
            type: rewardType === 2 ? 3 : (data.cdk ? 1 : 2),
          }),
          ...this.trackGameParams,
        })
        this.triggerVisible(true, rewardType === 2 ? 6 : (data.cdk ? 0 : 1))
        this.getGiftList()
      }).catch((err) => {
        const { code, msg } = err
        // 94007 - 未查询到游戏记录
        // 94008 - 角色等级不满足条件 当前值/目标值
        // 94010 - 活动期间付费不满足条件 当前值/目标值
        const [a, b] = msg.split('/')
        this.progressAttrs.currentVal = a * 1
        this.progressAttrs.targetVal = b * 1
        this.eventTrack({
          event: "game_transfer_draw_unfinished_condite",
          event_field: this.getTrackInfo({
            level,
            gift_id: giftId,
            gift_name: giftName,
            gift_value: giftValue,
            draw_condite: drawCondite,
            type: codeMapType[code],
            cur_value: code === 94007 ? undefined : this.progressAttrs.currentVal,
            tar_value: code === 94007 ? undefined : this.progressAttrs.targetVal,
          }),
          ...this.trackGameParams,
        })
        if (code === 94007) {
          this.triggerVisible(true, 2)
          return
        }
        if (code === 94008) {
          this.triggerVisible(true, 3)
        }
        if (code === 94010) {
          this.triggerVisible(true, 4)
        }
      }).finally(() => {
        this.receiveLoading = false
      })
    },
    triggerVisible (v, type) {
      if (type !== undefined) {
        this.feedbackType = type
      }
      this.visible = v
    },
    getTrackInfo (params = {}) {
      const { id, name, lev } = this.$route.query
      return JSON.stringify({
        activity_id: id,
        activity_name: name,
        level: lev,
        ...params,
      })
    },
    getConditionStr (gift = {}) {
      const { drawCondite, condite } = gift
      if (drawCondite === 0) return '活动期间进入游戏可领'
      if (drawCondite === 1) return `新注册角色达${condite}级可领`
      if (drawCondite === 2) return `活动期间充值${condite}元可领`
    },
    // 跳转原生页面     
    handleGoGameDetail () {
      const { gameId } = this.gameInfo
      const data = {
        routePath: "/main/game/GameDetailActivity",
        fromPageType: this.isWx ? 57 : 40, // 数据归因
        extraParams: gameId,
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    // 积分商城
    handleGoScore () {
      const data = {
        routePath: "/task/CreditStoreActivity",
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    handleGoGift () {
      const data = {
        routePath: "/gift/MineGiftActivity",
        extraParams: this.isWx ? 3 : 2, // 2 -> BT盒子活动 3-> 玩心盒子活动
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr)
    },
    // 联系客服
    onRelationServer() {
      this.$router.push({
        name: `box.customerService`,
      });
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
.pageNative {
  width: 100vw;
  min-height: 100vh;
}
.title {
  padding: 4px;
}
.header {
  padding: 4px;
}
.activity_places {
  width: 100%;
  height: 82px;
  // background: #ffffff;
  display: flex;
  align-items: flex-end;
  
  .place_icon {
    width: 45px;
  }
  .active_place {
    width: 60px !important;
  }
}
// 更多游戏
.more_games {
  display: flex;
  flex-wrap: wrap;
  padding: 12px 14px 0px;
  margin: 0 auto;
  max-height: 260px;
  overflow: auto;
  .more_game {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 84px;
    margin-bottom: 8px;
    .more_game_icon {
      width: 58px;
      height: 58px;
      margin-bottom: 5px;
      border-radius: 6px;
    }
  }
}
// 更多游戏
.morePlace {
  width: 55px;
  margin-left: 5px;
  text-align: center;
  > img {
    width: 40px;
  }
  .moreText {
    font-weight: 500;
    text-align: center;
    color: #fc5f5e;
    font-size: 12px;
    margin-top: 2px;
  }
}
</style>
